const userTable = {
  columns: {
    id: "ID",
    name: "Name",
    email: "Email",
    institution: "Institution",
    status: "Status",
    role: "Role",
    projects: "Projects",
    created: "Created",
    actions: "Actions",
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    pendingActivation: "Pending Activation",
    pendingActivationTooltip:
      "⚠️ 2FA in reset mode - user must set up 2FA on next login",
  },
  roles: {
    manager: "Manager",
    dataUploader: "Data Uploader",
    pi: "PI",
    researcher: "Researcher",
    owner: "Owner",
  },
  actionsMenu: {
    userActionsTitle: "User actions",
    removeFromProjectDirect: "➖ Remove from Project",
    removeFromProjectDisabledTooltip:
      "PIs cannot remove other PIs. Contact an org admin.",
    disable2fa: "🔓 Disable 2FA",
    addToProjectToggle: "➕ Add to project",
    removeFromProjectToggle: "➖ Remove from project",
    promoteToPI: "⬆ Promote to PI",
    revokePI: "⬇ Revoke PI",
  },
  invited: {
    badge: "Invited",
    copyLink: "Copy link",
    revoke: "Revoke",
  },
  dialog: {
    title: "Confirm Action",
    disable2faBody:
      "Are you sure you want to disable 2FA for this user? They will be required to set up 2FA again on their next login.",
    removeBodyNamed:
      'Are you sure you want to remove this user from "{{title}}"?',
    removeBodyGeneric:
      "Are you sure you want to remove this user from the project?",
    addBodyNamed: 'Add this user as a researcher to "{{title}}"?',
    addBodyGeneric: "Add this user as a researcher to the project?",
    promotePIBody:
      "Promote this user to Principal Investigator? They will be able to create projects and manage their own research projects.",
    revokePIBody:
      "Revoke this user's PI status? They will be demoted to Researcher and removed as PI from any active projects they currently lead.",
    processing: "Processing...",
  },
};

export default userTable;
